import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';
import {CommentsModel} from './comments.model';


@Injectable({   providedIn: 'root' })
export class CommentsService extends DaoGeneric<CommentsModel> {
  private url = `${environment.baseUrl}/dar/comment/`;
  extraParams: Map<string, string> = new Map<string, string>();


  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getMessages(commentType: number = null, dossierId: number) {
    this.extraParams.set('dossier', dossierId.toString());
    this.extraParams.delete('type');
    if (commentType) {
      this.extraParams.set('type', commentType.toString());
    }
    return this.listAllItems(this.extraParams);
  }
}
